module.exports = __webpack_public_path__ + "static/media/quote-darwin-smith.f6fc051e.png";